function bmAddBootstrapClasses() {
	jQuery('.bm-Button-Wrapper a').addClass('btn');
}

window.addEventListener('load', bmAddBootstrapClasses);